import { render, staticRenderFns } from "./PurchaseInvoices.vue?vue&type=template&id=2f178236&scoped=true"
import script from "./PurchaseInvoices.vue?vue&type=script&lang=ts"
export * from "./PurchaseInvoices.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInvoices.vue?vue&type=style&index=0&id=2f178236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f178236",
  null
  
)

export default component.exports